import { Modal, Fade, Backdrop, Card, Grid, Icon } from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import { tooltip } from "leaflet";
import DinamicCard from "components/Cards/InfoCards/DinamicCard";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: "50%", lg: "40%", xl: "20%"},
};

export default function DinamicModal({ open, handleClose, title, data }) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Card sx={style}>
          <DinamicCard
            title={title}
            data={data}
            actions={[{
              name: "cerrar",
              color: "dark",
              icon: "close",
              action: handleClose,
            }]}
            noBg={true}
          />
        </Card>
      </Fade>
    </Modal>
  );
}

DinamicModal.defaultProps = {
  title: "title",
  data: {},
};

DinamicModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};
